/** Product types hidden from kids-girl when using the women's catalog (kids / teens). */
export const KIDS_GIRL_EXCLUDED_TYPE_VALUES = new Set(['night-wear', 'lingerie']);

export function filterKidsGirlProductTypes(types) {
  if (!Array.isArray(types)) return [];
  return types.filter((t) => !KIDS_GIRL_EXCLUDED_TYPE_VALUES.has(t?.value));
}

/** Drop night wear / lingerie from an existing kids-girl multi-type selection. */
export function stripKidsGirlExcludedSelections(types) {
  if (!Array.isArray(types)) return [];
  return types.filter(
    (t) => t.category !== 'kids-girl' || !KIDS_GIRL_EXCLUDED_TYPE_VALUES.has(t.value)
  );
}

/** Kids age buckets that reuse adult garment catalogs in the generate UI. */
export function kidsUsesAdultCatalog(kidAgeRange) {
  return kidAgeRange === 'kids' || kidAgeRange === 'teens';
}

export function kidsBoyUsesMensCatalog(kidAgeRange) {
  return kidsUsesAdultCatalog(kidAgeRange);
}

export function kidsGirlUsesWomensCatalog(kidAgeRange) {
  return kidsUsesAdultCatalog(kidAgeRange);
}

export function resolveKidsCatalogCategory(categoryValue, kidAgeRange) {
  if (categoryValue === 'kids-boy' && kidsBoyUsesMensCatalog(kidAgeRange)) {
    return 'men-clothing';
  }
  if (categoryValue === 'kids-girl' && kidsGirlUsesWomensCatalog(kidAgeRange)) {
    return 'women-clothing';
  }
  return categoryValue;
}

/** @deprecated Use resolveKidsCatalogCategory */
export function resolveKidsBoyCatalogCategory(categoryValue, kidAgeRange) {
  return resolveKidsCatalogCategory(categoryValue, kidAgeRange);
}

export function isMensCatalogContext(categoryValue, kidAgeRange) {
  return (
    categoryValue === 'men-clothing' ||
    (categoryValue === 'kids-boy' && kidsBoyUsesMensCatalog(kidAgeRange))
  );
}

export function isWomensCatalogContext(categoryValue, kidAgeRange) {
  return (
    categoryValue === 'women-clothing' ||
    (categoryValue === 'kids-girl' && kidsGirlUsesWomensCatalog(kidAgeRange))
  );
}
